// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorControllerInfoContent, unionToElevatorControllerInfoContent, unionListToElevatorControllerInfoContent } from './elevator-controller-info-content';
import { FirmwareVersionMessage, FirmwareVersionMessageT } from './firmware-version-message';
import { FloorLabelMessage, FloorLabelMessageT } from './floor-label-message';


export class ElevatorControllerInfoMessage implements flatbuffers.IUnpackableObject<ElevatorControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorControllerInfoMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControllerInfoMessage):ElevatorControllerInfoMessage {
  return (obj || new ElevatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorControllerInfoMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControllerInfoMessage):ElevatorControllerInfoMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorControllerInfoMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

messageType():ElevatorControllerInfoContent {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : ElevatorControllerInfoContent.NONE;
}

message<T extends flatbuffers.Table>(obj:any):any|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
}

static startElevatorControllerInfoMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessageType(builder:flatbuffers.Builder, messageType:ElevatorControllerInfoContent) {
  builder.addFieldInt8(0, messageType, ElevatorControllerInfoContent.NONE);
}

static addMessage(builder:flatbuffers.Builder, messageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, messageOffset, 0);
}

static endElevatorControllerInfoMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 6) // message
  return offset;
}

static createElevatorControllerInfoMessage(builder:flatbuffers.Builder, messageType:ElevatorControllerInfoContent, messageOffset:flatbuffers.Offset):flatbuffers.Offset {
  ElevatorControllerInfoMessage.startElevatorControllerInfoMessage(builder);
  ElevatorControllerInfoMessage.addMessageType(builder, messageType);
  ElevatorControllerInfoMessage.addMessage(builder, messageOffset);
  return ElevatorControllerInfoMessage.endElevatorControllerInfoMessage(builder);
}

unpack(): ElevatorControllerInfoMessageT {
  return new ElevatorControllerInfoMessageT(
    this.messageType(),
    (() => {
      const temp = unionToElevatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })()
  );
}


unpackTo(_o: ElevatorControllerInfoMessageT): void {
  _o.messageType = this.messageType();
  _o.message = (() => {
      const temp = unionToElevatorControllerInfoContent(this.messageType(), this.message.bind(this));
      if(temp === null) { return null; }
      return temp.unpack()
  })();
}
}

export class ElevatorControllerInfoMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public messageType: ElevatorControllerInfoContent = ElevatorControllerInfoContent.NONE,
  public message: FirmwareVersionMessageT|FloorLabelMessageT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const message = builder.createObjectOffset(this.message);

  return ElevatorControllerInfoMessage.createElevatorControllerInfoMessage(builder,
    this.messageType,
    message
  );
}
}
